import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { JournalEntryListRow } from "../views/journalEntryListViewConfig";

export const JournalEntryExcludeFrom1099Cell = memo(
    ({
        getValue,
    }: CellContext<ViewTableFeatures, JournalEntryListRow, boolean>) => (
        <ViewTableCell>{getValue() ? "Yes" : "No"}</ViewTableCell>
    ),
);

JournalEntryExcludeFrom1099Cell.displayName = "JournalEntryExcludeFrom1099Cell";
